module.exports = __webpack_public_path__ + "img/platinumRiver.e8677a6.webp";